/**
 * Persistencia del bloqueo por inactividad de operarios.
 * Usa localStorage para sobrevivir a recargas y sincronizar pestañas.
 */

const STORAGE_PREFIX = 'wh:operator-session-lock:';

export interface OperatorLockState {
  isLocked: boolean;
  /** Timestamp absoluto de expiración; null si ya está bloqueado */
  expiresAt: number | null;
}

export function getOperatorLockStorageKey(userId: number): string {
  return `${STORAGE_PREFIX}${userId}`;
}

export function readOperatorLockState(userId: number): OperatorLockState | null {
  try {
    const raw = localStorage.getItem(getOperatorLockStorageKey(userId));
    if (!raw) return null;

    const parsed = JSON.parse(raw) as Partial<OperatorLockState>;
    if (typeof parsed?.isLocked !== 'boolean') return null;

    const expiresAt =
      typeof parsed.expiresAt === 'number' && Number.isFinite(parsed.expiresAt) ? parsed.expiresAt : null;

    return { isLocked: parsed.isLocked, expiresAt };
  } catch {
    return null;
  }
}

export function writeOperatorLockState(userId: number, state: OperatorLockState): void {
  try {
    localStorage.setItem(getOperatorLockStorageKey(userId), JSON.stringify(state));
  } catch {
    // Silenciar errores de cuota / modo privado
  }
}

export function clearOperatorLockState(userId: number): void {
  try {
    localStorage.removeItem(getOperatorLockStorageKey(userId));
  } catch {
    // Silenciar errores de storage
  }
}
